const SET_PAGE_LIBRARY_FILTER = 'browseFilters/SET_PAGE_LIBRARY_FILTER';
const SET_ASSIGNMENTS_FILTER = 'browseFilters/SET_ASSIGNMENTS_FILTER';
const SET_MY_CARDS_FILTER = 'browseFilters/SET_MY_CARDS_FILTER';
const SET_LIBRARY_FILTER = 'browseFilters/SET_LIBRARY_FILTER';
const SET_CORE_CONCEPTS = 'browseFilters/SET_CORE_CONCEPTS';
const SET_SUBJECTS = 'browseFilters/SET_SUBJECTS';
const SET_DOMAINS = 'browseFilters/SET_DOMAINS';
const SET_GRADES = 'browseFilters/SET_GRADES';
const SET_UNITS = 'browseFilters/SET_UNITS';
const FETCH_GRADE_SUBJECTS = 'browseFilters/FETCH_GRADE_SUBJECTS';
const RESET_GRADE_SUBJECTS = 'browseFilters/RESET_GRADE_SUBJECTS';

export default {
  SET_PAGE_LIBRARY_FILTER,
  SET_ASSIGNMENTS_FILTER,
  SET_MY_CARDS_FILTER,
  SET_LIBRARY_FILTER,
  SET_CORE_CONCEPTS,
  SET_SUBJECTS,
  SET_DOMAINS,
  SET_GRADES,
  SET_UNITS,
  FETCH_GRADE_SUBJECTS,
  RESET_GRADE_SUBJECTS,
};



// WEBPACK FOOTER //
// ./src/app/browse-filters/store/mutation-types.js